/**
 * Ten Reasons → Save LP funnel: Meta ViewContent on landing (session cohort).
 * Landing only. Step 1/2 read the same STORAGE_KEY / STORAGE_VALUE via sessionStorage
 * in SaveLPTracking / TrackingService static fields in save-lp-step1-scripts.js
 * and save-lp-step2-scripts.js — keep in sync.
 */
(function () {
  var NS = 'SaveLPTenReasonsMetaShift';
  var STORAGE_KEY = 'carpe_ten_reasons_meta_shift_v1';
  var STORAGE_VALUE = '1';

  function safeFbqTrack(eventName, retries) {
    if (typeof fbq === 'function') {
      fbq('track', eventName);
    } else if (retries > 0) {
      setTimeout(function () {
        safeFbqTrack(eventName, retries - 1);
      }, 100);
    } else {
      console.warn('fbq not found after multiple retries (' + eventName + ')');
    }
  }

  window[NS] = {
    STORAGE_KEY: STORAGE_KEY,
    STORAGE_VALUE: STORAGE_VALUE,

    isTenReasonsMetaShiftCohort: function () {
      try {
        return sessionStorage.getItem(STORAGE_KEY) === STORAGE_VALUE;
      } catch (e) {
        return false;
      }
    },

    /** Same retry budget as SaveLPTracking.safeTrackFBViewContent on step 1 */
    trackViewContentOnLanding: function (retries) {
      safeFbqTrack('ViewContent', retries !== undefined ? retries : 10);
    },

    /** Same bare payload and retry budget as TrackingService.sendFbAddToCart on step 2 */
    safeTrackFBAddToCart: function (retries) {
      safeFbqTrack('AddToCart', retries !== undefined ? retries : 50);
    },
  };
})();

document.addEventListener('DOMContentLoaded', function () {
  var M = window.SaveLPTenReasonsMetaShift;
  if (!M) return;
  try {
    sessionStorage.setItem(M.STORAGE_KEY, M.STORAGE_VALUE);
  } catch (e) { }
  M.trackViewContentOnLanding();
});